module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Ingresar Factura, NC o ND")])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "mobile",
    attrs: {
      "title": "Cargar Factura, NC o ND",
      "visible": _vm.showModal,
      "append-to-body": true,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('el-divider'), _vm._v(" "), _c('el-form', {
    ref: "formRef",
    staticClass: "form-container",
    attrs: {
      "rules": _vm.formRules,
      "model": _vm.document,
      "label-width": "160px"
    }
  }, [(_vm.hesMigo.length !== 0) ? _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Código de Documentación")]) : _vm._e(), _vm._v(" "), (_vm.hesMigo.length !== 0) ? _c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Código de Documentación"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Código de Documentación"
    },
    on: {
      "change": _vm.updateDescriptionTipo
    },
    model: {
      value: (_vm.document.code),
      callback: function($$v) {
        _vm.$set(_vm.document, "code", $$v)
      },
      expression: "document.code"
    }
  }, _vm._l((_vm.hesMigo), function(item) {
    return _c('el-option', {
      key: item.idHes,
      attrs: {
        "label": item.number,
        "value": item.idHes
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hesMigo.length !== 0) ? _c('div', [_c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Descripción",
      "size": "small"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.document.description),
      callback: function($$v) {
        _vm.$set(_vm.document, "description", $$v)
      },
      expression: "document.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Tipo de código",
      "size": "small"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.document.tipo),
      callback: function($$v) {
        _vm.$set(_vm.document, "tipo", $$v)
      },
      expression: "document.tipo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Datos de la operacion")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Tipo de operación",
      "prop": "documenttype"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de operación"
    },
    model: {
      value: (_vm.document.documenttype),
      callback: function($$v) {
        _vm.$set(_vm.document, "documenttype", $$v)
      },
      expression: "document.documenttype"
    }
  }, _vm._l((_vm.documentType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Código de AFIP",
      "size": "small",
      "prop": "codigoAFIP"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.codigoAFIP),
      callback: function($$v) {
        _vm.$set(_vm.document, "codigoAFIP", $$v)
      },
      expression: "document.codigoAFIP"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Letra",
      "size": "small",
      "prop": "letra"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.letra),
      callback: function($$v) {
        _vm.$set(_vm.document, "letra", $$v)
      },
      expression: "document.letra"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Numero",
      "size": "small",
      "prop": "numero"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.numero),
      callback: function($$v) {
        _vm.$set(_vm.document, "numero", $$v)
      },
      expression: "document.numero"
    }
  })], 1), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Datos CAE")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Fecha de Vencimiento",
      "size": "small",
      "prop": "fechaVencimiento"
    }
  }, [_c('el-date-picker', {
    staticClass: "form-date",
    attrs: {
      "type": "date",
      "placeholder": "Selecciona fecha de Vencimiento",
      "default-value": new Date()
    },
    model: {
      value: (_vm.document.fechaVencimiento),
      callback: function($$v) {
        _vm.$set(_vm.document, "fechaVencimiento", $$v)
      },
      expression: "document.fechaVencimiento"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Nº",
      "size": "small",
      "prop": "NroCAE"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.NroCAE),
      callback: function($$v) {
        _vm.$set(_vm.document, "NroCAE", $$v)
      },
      expression: "document.NroCAE"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-upload",
    attrs: {
      "size": "small",
      "label": "PDF",
      "prop": "pdfDoc"
    }
  }, [_c('pdf-file', {
    staticClass: "form-pdf",
    attrs: {
      "pdfFilePath": _vm.document.pdfDoc,
      "habModificaPdf": _vm.habModificaPdf,
      "id": "documento",
      "prop": "documento"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.document, "pdfDoc", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.document, "pdfDoc", $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.loadOperationType === true) ? _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Datos de Referencia")]) : _vm._e(), _vm._v(" "), (_vm.loadOperationType === true) ? _c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Tipo de transacción"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de transacción"
    },
    model: {
      value: (_vm.document.ocType),
      callback: function($$v) {
        _vm.$set(_vm.document, "ocType", $$v)
      },
      expression: "document.ocType"
    }
  }, _vm._l((_vm.acceptanceType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.document.ocType === '1') ? _c('el-form-item', {
    key: _vm.index,
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "input-text"
  }, [_vm._v("Número de operación")])]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view1",
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Numero de HES"
    },
    model: {
      value: (_vm.document.ocNumber),
      callback: function($$v) {
        _vm.$set(_vm.document, "ocNumber", $$v)
      },
      expression: "document.ocNumber"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "input-view2",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "35px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.addOcNumber
    }
  }, [_vm._v("+")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.document.ocNumbers), function(ocNumber, index) {
    return (_vm.document.ocType === '1') ? _c('el-form-item', {
      key: index,
      staticClass: "form-input",
      attrs: {
        "size": "small"
      }
    }, [_c('el-row', [_c('el-col', {
      staticClass: "input-view1",
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Numero de HES"
      },
      model: {
        value: (ocNumber.value),
        callback: function($$v) {
          _vm.$set(ocNumber, "value", $$v)
        },
        expression: "ocNumber.value"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "input-view2",
      attrs: {
        "span": 12
      }
    }, [_c('el-button', {
      staticStyle: {
        "margin-left": "35px"
      },
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOcNumber(index)
        }
      }
    }, [_vm._v("-")])], 1)], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.document.ocType === '2') ? _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "input-text"
  }, [_vm._v("Número de operación")])]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view1",
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Numero de MIGO"
    },
    model: {
      value: (_vm.document.migoNumber),
      callback: function($$v) {
        _vm.$set(_vm.document, "migoNumber", $$v)
      },
      expression: "document.migoNumber"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Importes")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Importe Total",
      "size": "small",
      "prop": "importeTotal"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.importeTotal),
      callback: function($$v) {
        _vm.$set(_vm.document, "importeTotal", $$v)
      },
      expression: "document.importeTotal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Importe Impuesto",
      "size": "small",
      "prop": "importeImpuesto"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.importeImpuesto),
      callback: function($$v) {
        _vm.$set(_vm.document, "importeImpuesto", $$v)
      },
      expression: "document.importeImpuesto"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Porcentaje Impuesto",
      "size": "small",
      "prop": "porcentajeImpuesto"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.porcentajeImpuesto),
      callback: function($$v) {
        _vm.$set(_vm.document, "porcentajeImpuesto", $$v)
      },
      expression: "document.porcentajeImpuesto"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Moneda",
      "size": "small",
      "prop": "moneda"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.moneda),
      callback: function($$v) {
        _vm.$set(_vm.document, "moneda", $$v)
      },
      expression: "document.moneda"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Tipo de Cambio",
      "size": "small",
      "prop": "tipoDeCambio"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.tipoDeCambio),
      callback: function($$v) {
        _vm.$set(_vm.document, "tipoDeCambio", $$v)
      },
      expression: "document.tipoDeCambio"
    }
  })], 1)], 2), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.validateForm
    }
  }, [_vm._v("\n            Guardar\n        ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n            Cancelar\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbd092f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/UploadReceipt.vue
// module id = 650
// module chunks = 1